import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import Swal from "sweetalert2";
import moment from "moment";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Row,
  Col,
  Card,
  CardText,
  CardBody,
  CardTitle,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";

const ClassConfirmation = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCompSubmitted, setIsCompSubmitted] = useState(false);
  const [isCompEditMode, setIsCompEditMode] = useState(false);
  const [fixAttendance, setFixAttendance] = useState("");
  const [fixReason, setFixReason] = useState("");
  const [compAttendance, setCompAttendance] = useState("");
  const [compId, setCompId] = useState(0);
  const [compCount, setCompCount] = useState(0);
  const [compResults, setCompResults] = useState([]);
  const [classDate, setClassDate] = useState([]);
  const [results, setResults] = useState([]);
  const [compData, setCompData] = useState("");
  const [data, setData] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFixHoliday, setIsFixHoliday] = useState(false);
  const [isCompHoliday, setIsCompHoliday] = useState(false);
  const [holidayDate, setHolidayDate] = useState("");
  const [fixDropdownOpen, setFixDropdownOpen] = useState(false);
  const [compDropdownOpen, setCompDropdownOpen] = useState(false);
  const [isFixHolidayChecking, setIsFixHolidayChecking] = useState(false);
  const [isCompHolidayChecking, setIsCompHolidayChecking] = useState(false);

  const token = localStorage.getItem("authToken");
  const user = JSON.parse(localStorage.getItem("authUser"));

  document.title = "Class Confirmation | KDC - Admin";

  useEffect(() => {
    const storedUser = localStorage.getItem("authUser");
    if (!storedUser) return;

    const userData = JSON.parse(storedUser);

    const loadDetails = async () => {
      try {
        const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentClassDetailsById?studentId=${userData.Id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const json = await res.json();
        const classList = json?.recordsets?.[0] || [];

        setResults(classList);

        if (classList.length === 1) {
          setData(classList[0]);
        }

      } catch (err) {
        console.error(err);
      }
    };

    const loadCompCount = async () => {
      try {
        const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentCompClassCount?studentId=${userData.Id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const json = await res.json();
        const id = json?.recordsets?.[0]?.[0]?.Id || 0;
        const count = json?.recordsets?.[0]?.[0]?.QueueCount || 0;
        setCompId(id);
        setCompCount(count);

      } catch (err) {
        console.error(err);
      }
    };

    loadDetails();
    loadCompCount();
  }, [token]);

  useEffect(() => {
    const fetchSlotAvailability = async () => {
      try {
        const targetDay = getCompTargetDay();
        const targetDate = getCompTargetDate();
        const formattedDate = targetDate.toLocaleDateString("en-CA");

        const res = await fetch(`https://api.kunalsdrumclass.com/api/GetCompSlotAvailability?classDate=${formattedDate}&day=${targetDay}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const json = await res.json();
        const classList = json?.recordsets?.[0] || [];

        setCompResults(classList);
      } catch (err) {
        console.error("Slot availability error:", err);
      }
    };

    fetchSlotAvailability();

  }, []);

  const checkHoliday = async (date) => {
    try {
      const res = await fetch(
        `https://api.kunalsdrumclass.com/api/CheckHolidayByDate?date=${date}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const json = await res.json();

      return json?.recordsets?.[0]?.[0]?.IsHoliday === 1;
    } catch (err) {
      console.error("Holiday check error:", err);
      return false;
    }
  };

  useEffect(() => {
    if (!data?.Day_Of_Week) return;

    const loadSubmittedData = async () => {
      try {
        setLoading(true);
        setIsFixHolidayChecking(true);
        const nextClassDate = getNextDateByDay(data.Day_Of_Week);
        setClassDate(nextClassDate);
        const formattedDate = nextClassDate.toLocaleDateString("en-CA");
        const holiday = await checkHoliday(formattedDate);
        if (holiday) {
          setHolidayDate(formattedDate);
        }
        setIsFixHoliday(holiday);

        const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentResponse?studentId=${user.Id}&studentClassId=${data.Student_Class_Id}&classDate=${formattedDate}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const result = await res.json();
        const record = result?.recordsets?.[0]?.[0];

        if (record) {
          setFixAttendance(record.Will_Attend == 1 ? "1" : "0");
          setFixReason(record.Reason || "");
          setIsSubmitted(true);
          setIsEditMode(false);
        }

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setIsFixHolidayChecking(false);
      }
    };

    const loadCompSubmittedData = async () => {
      try {
        setLoading(true);
        setIsCompHolidayChecking(true);
        const targetDate = getCompTargetDate();
        const formattedDate = targetDate.toLocaleDateString("en-CA");
        const holiday = await checkHoliday(formattedDate);
        if (holiday) {
          setHolidayDate(formattedDate);
        }
        setIsCompHoliday(holiday);

        const res = await fetch(
          `https://api.kunalsdrumclass.com/api/GetStudentCompResponse?studentId=${user.Id}&classDate=${formattedDate}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const json = await res.json();
        const record = json?.recordsets?.[0]?.[0];

        if (record) {
          setCompAttendance("1");
          setCompData({
            Batch_Day: record.Day_Of_Week,
            Batch_Time: record.Time_Slot
          });
          setIsCompSubmitted(true);
          setIsCompEditMode(false);
        }

      } catch (error) {
        console.error("Comp API error:", error);
      } finally {
        setLoading(false);
        setIsCompHolidayChecking(false);
      }
    };

    loadSubmittedData();
    loadCompSubmittedData();

  }, [data]);

  const getNextDateByDay = (dayName) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];

    const today = new Date();
    const todayDayIndex = today.getDay();
    const targetDayIndex = days.indexOf(dayName);

    if (targetDayIndex === -1) return null;

    let diff = targetDayIndex - todayDayIndex;

    if (diff <= 0) {
      diff += 7;
    }

    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + diff);

    return nextDate;
  };

  const getCompTargetDate = () => {
    const now = new Date();
    const targetDate = new Date(now);
    targetDate.setHours(0, 0, 0, 0);

    const day = now.getDay();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    if (day === 0 || (day >= 1 && day <= 4)) {
      if (currentMinutes >= 20 * 60) {
        targetDate.setDate(targetDate.getDate() + 1);
      }
      return targetDate;
    }

    if (day === 5 || day === 6) {
      if (currentMinutes >= 16 * 60) {
        targetDate.setDate(targetDate.getDate() + 1);
      }
      return targetDate;
    }

    return targetDate;
  };

  const getCompTargetDay = () => {
    const targetDate = getCompTargetDate();
    return targetDate.toLocaleDateString("en-US", { weekday: "long" });
  };

  const bookingWindows = {
    Monday: {
      startDay: "Saturday",
      startTime: "16:00",
      endDay: "Sunday",
      endTime: "18:30",
    },

    Tuesday: {
      startDay: "Sunday",
      startTime: "16:00",
      endDay: "Monday",
      endTime: "18:30",
    },

    Wednesday: {
      startDay: "Monday",
      startTime: "16:00",
      endDay: "Tuesday",
      endTime: "18:30",
    },

    Thursday: {
      startDay: "Tuesday",
      startTime: "16:00",
      endDay: "Wednesday",
      endTime: "18:30",
    },

    Friday: {
      startDay: "Wednesday",
      startTime: "16:00",
      endDay: "Thursday",
      endTime: "18:30",
    },

    Saturday: {
      startDay: "Thursday",
      startTime: "09:00",
      endDay: "Friday",
      endTime: "14:30",
    },

    Sunday: {
      startDay: "Friday",
      startTime: "09:00",
      endDay: "Saturday",
      endTime: "14:30",
    },
  };

  const dayIndexes = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const getDateForDay = (targetDay, referenceDate = new Date()) => {
    const result = new Date(referenceDate);
    const currentDay = result.getDay();
    const targetDayIndex = dayIndexes[targetDay];

    let diff = targetDayIndex - currentDay;

    // Get the nearest occurrence of the requested day
    if (diff > 0) {
      diff -= 7;
    }

    result.setDate(result.getDate() + diff);

    return result;
  };

  const setTime = (date, time) => {
    const [hours, minutes] = time.split(":").map(Number);

    const result = new Date(date);
    result.setHours(hours, minutes, 0, 0);

    return result;
  };

  const canEnableSubmit = () => {
    if (!data?.Day_Of_Week) return false;

    const nextClassDate = getNextDateByDay(data.Day_Of_Week);
    if (!nextClassDate) return false;

    const now = new Date();
    const startDate = new Date(nextClassDate);
    const endDate = new Date(nextClassDate);

    const day = data.Day_Of_Week;

    if (day === "Saturday") {
      startDate.setDate(startDate.getDate() - 2);
      startDate.setHours(9, 0, 0, 0);

      endDate.setDate(endDate.getDate() - 1);
      endDate.setHours(15, 0, 0, 0);

      return now >= startDate && now <= endDate;
    }

    if (day === "Sunday") {
      startDate.setDate(startDate.getDate() - 2);
      startDate.setHours(9, 0, 0, 0);

      endDate.setDate(endDate.getDate() - 1);
      endDate.setHours(15, 0, 0, 0);

      return now >= startDate && now <= endDate;
    }

    startDate.setDate(startDate.getDate() - 2);
    startDate.setHours(16, 0, 0, 0);

    endDate.setDate(endDate.getDate() - 1);
    endDate.setHours(19, 0, 0, 0);

    return now >= startDate && now <= endDate;
  };

  const isWeekendSlotClosed = (item) => {
    const now = new Date();
    const classDate = moment(item.ClassDate, "YYYY-MM-DD", true);
    if (!classDate.isValid()) return false;

    const classDay = classDate.day();
    if (classDay !== 0 && classDay !== 6) return false;

    const today = moment(now).startOf("day");
    const targetDay = classDate.clone().startOf("day");
    if (targetDay.isBefore(today)) return true;

    if (targetDay.isAfter(today)) return false;

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startTime = item.Batch_Time.split("-")[0].trim();
    const slotMoment = moment(startTime, "hh:mmA", true);

    if (!slotMoment.isValid()) return false;

    const slotStartMinutes =
      slotMoment.hours() * 60 + slotMoment.minutes();

    if (slotStartMinutes >= 600 && slotStartMinutes < 840) {
      return currentMinutes >= 570;
    }

    if (slotStartMinutes >= 840 && slotStartMinutes < 1080) {
      return currentMinutes >= 810;
    }

    return false;
  };

  const isCompTimeDisabled = () => {
    const now = new Date();
    const day = now.getDay();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    if (day >= 1 && day <= 4) {
      if (currentMinutes <= (15 * 60 + 30)) {
        return false;
      }

      if (
        currentMinutes > (15 * 60 + 30) &&
        currentMinutes < (20 * 60)
      ) {
        return true;
      }

      return false;
    }

    if (day === 5) {
      if (currentMinutes >= 16 * 60) {
        return false;
      }

      if (
        currentMinutes > (15 * 60 + 30) &&
        currentMinutes < (16 * 60)
      ) {
        return true;
      }

      return false;
    }

    if (day === 6 || day === 0) {
      return false;
    }

    return true;
  };

  const handleFixSubmit = async (e) => {
    setError("");
    e.preventDefault();

    if (!data?.Day_Of_Week || !data?.Time) {
      setError("Please select class");
      return;
    }

    if (fixAttendance === "") {
      setError("Please select Yes or No");
      return;
    }

    if (fixAttendance === "0" && fixReason.trim() === "") {
      setError("Reason is required");
      return;
    }

    try {
      setLoading(true);
      const nextClassDate = getNextDateByDay(data.Day_Of_Week);
      const payload = {
        studentId: user.Id,
        studentClassId: data.Student_Class_Id,
        classDate: nextClassDate.toLocaleDateString("en-CA"),
        dayOfWeek: data.Day_Of_Week,
        timeSlot: data.Time,
        willAttend: fixAttendance === "1" ? true : false,
        reason: fixAttendance === "0" ? fixReason : "",
      };

      await fetch(`https://api.kunalsdrumclass.com/api/InsertUpdateStudentResponse`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      await Swal.fire({
        title: "Success!",
        text: "details submitted successfully!",
        icon: "success",
        customClass: {
          popup: "swal2-material-ui",
          confirmButton: "btn btn-sm rounded-8 btn-primary",
        },
      });

      setIsSubmitted(true);
      setIsEditMode(false);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong while saving details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCompSubmit = async (e) => {
    setError("");
    e.preventDefault();

    if (!compData?.Batch_Day || !compData?.Batch_Time) {
      setError("Please select class");
      return;
    }

    if (compAttendance === "") {
      setError("Please select Yes or No");
      return;
    }

    const result = await Swal.fire({
      title: "Warning!",
      text: `Are you sure you want to take comp class?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, continue",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
      customClass: {
        popup: "swal2-material-ui",
        confirmButton: "delete-alert",
        cancelButton: "cancel-alert",
      },
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);
      if (compAttendance === "1") {
        const targetDate = getCompTargetDate();
        const payload = {
          studentId: user.Id,
          compId: compId,
          classDate: targetDate.toLocaleDateString("en-CA"),
          day: compData?.Batch_Day,
          time: compData?.Batch_Time
        };

        const res = await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentBooking`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data.recordsets?.[0][0].Status === 2) {
          await Swal.fire({
            title: "Slot Full",
            text: "slot is full for this time. please select another time.",
            icon: "warning",
            customClass: {
              popup: "swal2-material-ui",
              confirmButton: "btn btn-sm rounded-8 btn-warning",
            },
          });
          
          setIsCompSubmitted(true);
          setIsCompEditMode(false);
        } else {
          await Swal.fire({
            title: "Success!",
            text: "details submitted successfully!",
            icon: "success",
            customClass: {
              popup: "swal2-material-ui",
              confirmButton: "btn btn-sm rounded-8 btn-primary",
            },
          });

          setIsCompSubmitted(true);
          setIsCompEditMode(false);
        }
      } else {
        await Swal.fire({
          title: "Success!",
          text: "details submitted successfully!",
          icon: "success",
          customClass: {
            popup: "swal2-material-ui",
            confirmButton: "btn btn-sm rounded-8 btn-primary",
          },
        });

        setIsCompSubmitted(true);
        setIsCompEditMode(false);
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong while saving details", "error");
    } finally {
      setLoading(false);
    }
  };

  const isFixDisabled = loading || isFixHolidayChecking || isFixHoliday || (isSubmitted && !isEditMode) || !canEnableSubmit() || Number(data?.Current_Swap_Count || 0) > 0;
  const allCompSlotsClosed = compResults.length > 0 && compResults.every((item) => isWeekendSlotClosed(item) || Number(item.Available_Seats) <= 0);
  const isCompDisabled = loading || isCompHolidayChecking || isCompHoliday || compCount === 0 || (isCompSubmitted && !isCompEditMode) || isCompTimeDisabled() || allCompSlotsClosed;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Class Confirmation"
          breadcrumbItems={[
            { title: "Class Confirmation" }
          ]}
        />
        <Row>
          <Col lg="12">
            {(isFixHoliday || isCompHoliday) && (
              <div>
                <p className="fw-semibold text-danger">
                  Note: Fix and Comp classes will be on Holiday on <span>{holidayDate ? moment(holidayDate).format("DD-MM-YYYY") : ""}</span>. Class selection will be available from the next class onward.
                </p>
              </div>
            )}
            <Card>
              <CardBody>
                <CardTitle className="h4 mt-0">
                  Fix Class (<span>{classDate ? moment(classDate).format("DD-MM-YYYY") : ""}</span>)
                </CardTitle>
                <hr style={{ border: "1px solid", opacity: 0.50 }} />
                <CardTitle className="h4 mt-0">
                  <div className="d-flex align-items-center gap-2">
                    {results.length > 1 ? (
                      <Dropdown isOpen={fixDropdownOpen} toggle={() => setFixDropdownOpen(!fixDropdownOpen)}>
                        <DropdownToggle
                          caret
                          className="btn btn-secondary btn-sm"
                        >
                          {data?.Day_Of_Week
                            ? `${data.Day_Of_Week} (${data.Time})`
                            : "Select Class *"}
                          <i className="mdi mdi-chevron-down" />
                        </DropdownToggle>

                        <DropdownMenu>
                          {results.map((item, index) => (
                            <DropdownItem
                              key={index}
                              active={data?.Day_Of_Week === item.Day_Of_Week}
                              onClick={() => {
                                setData(item);
                                setFixDropdownOpen(false);
                              }}
                            >
                              {item.Day_Of_Week} ({item.Time})
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      <span className="fw-semibold">
                        {data?.Day_Of_Week
                          ? `${data.Day_Of_Week} (${data.Time})`
                          : "No Class"}
                      </span>
                    )}
                  </div>
                </CardTitle>
                {loading ? (
                  <div className="text-center my-4">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <>
                    {data?.Day_Of_Week && bookingWindows[data.Day_Of_Week] && (
                      <p className="fw-semibold text-danger mt-3">
                        Note: Fix Class booking is allowed only from {" "}
                        {bookingWindows[data.Day_Of_Week].startDay}{" "}
                        {moment(bookingWindows[data.Day_Of_Week].startTime, "HH:mm").format("h:mm A")}{" "}
                        to {" "}
                        {bookingWindows[data.Day_Of_Week].endDay}{" "}
                        {moment(bookingWindows[data.Day_Of_Week].endTime, "HH:mm").format("h:mm A")}{" "}.
                        Booking is not allowed before or after this time.
                      </p>
                    )}
                    < hr style={{ border: "1px solid", opacity: 0.50 }} />
                    {Number(data?.Current_Swap_Count || 0) > 0 && (
                      <p className="fw-semibold text-danger">
                        This class was taken in advance. Class selection will be available from the next class onward.
                      </p>)}
                    <Row>
                      <Col sm="12">
                        <CardText className="mb-0">
                          <form onSubmit={handleFixSubmit}>
                            <div className="mb-3">
                              <div className="d-flex align-items-center gap-2 mb-2">
                                <span>Will you attend the class?</span>
                              </div>

                              <div className="d-flex gap-2 mb-3">
                                <button
                                  type="button"
                                  disabled={isFixDisabled}
                                  className={`btn w-md ${fixAttendance === "1" ? "btn-primary" : "btn-outline-primary"}`}
                                  onClick={() => setFixAttendance("1")}
                                >
                                  Yes
                                </button>

                                <button
                                  type="button"
                                  disabled={isFixDisabled}
                                  className={`btn w-md ${fixAttendance === "0" ? "btn-primary" : "btn-outline-primary"}`}
                                  onClick={() => setFixAttendance("0")}
                                >
                                  No
                                </button>
                              </div>
                            </div>

                            {fixAttendance === "0" && (
                              <div className="mb-3">
                                <label className="form-label" htmlFor="formmessage">
                                  Reason*
                                </label>
                                <textarea
                                  className="form-control"
                                  rows={3}
                                  style={{ resize: "vertical" }}
                                  value={fixReason}
                                  onChange={(e) => setFixReason(e.target.value)}
                                  disabled={isFixDisabled}
                                  placeholder="Reason"
                                />
                              </div>
                            )}
                            {error && <p className="text-danger">{error}</p>}
                            <div className="mt-3 d-flex gap-2">
                              <button type="submit" className="btn btn-primary" disabled={isFixDisabled}>
                                {isSubmitted ? "Update" : "Submit"}
                              </button>
                              {isSubmitted && !isEditMode && canEnableSubmit() && (
                                <button type="button" className="btn btn-secondary" onClick={() => setIsEditMode(true)}>
                                  Edit Response?
                                </button>
                              )}
                            </div>
                          </form>
                        </CardText>
                      </Col>
                    </Row>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="h4 mt-0">
                  Comp Class (<span>{moment().format("DD-MM-YYYY")}</span>)
                </CardTitle>
                <hr style={{ border: "1px solid", opacity: 0.50 }} />
                <CardTitle className="h4 mt-0">
                  <div className="d-flex align-items-center gap-2">
                    {compResults.length > 0 ? (
                      <Dropdown
                        isOpen={compDropdownOpen}
                        disabled={isCompDisabled}
                        toggle={() => setCompDropdownOpen(!compDropdownOpen)}
                      >
                        <DropdownToggle
                          caret
                          className="btn btn-secondary btn-sm"
                        >
                          {compData
                            ? `${compData.Batch_Day} (${compData.Batch_Time})`
                            : "Select Class *"}
                          <i className="mdi mdi-chevron-down" />
                        </DropdownToggle>

                        <DropdownMenu>
                          {compResults.map((item, index) => {
                            const isDisabled =
                              Number(item.Available_Seats) <= 0 ||
                              isWeekendSlotClosed(item);

                            return (
                              <DropdownItem
                                key={index}
                                disabled={isDisabled}
                                onClick={() => {
                                  if (!isDisabled) {
                                    setCompData(item);
                                    setCompDropdownOpen(false);
                                  }
                                }}
                              >
                                {item.Batch_Day} ({item.Batch_Time})
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      <span className="fw-semibold">No Class</span>
                    )}
                  </div>
                </CardTitle>
                <hr style={{ border: "1px solid", opacity: 0.50 }} />
                <Row>
                  <Col sm="12">
                    <CardText className="mb-0">
                      {loading ? (
                        <div className="text-center my-4">
                          <Spinner color="primary" />
                        </div>
                      ) : (
                        <form onSubmit={handleCompSubmit}>
                          <div className="mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <span>Will you attend the class?</span>
                            </div>

                            <div className="d-flex gap-2 mb-3">
                              <button
                                type="button"
                                disabled={isCompDisabled}
                                className={`btn w-md ${compAttendance === "1" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setCompAttendance("1")}
                              >
                                Yes
                              </button>
                            </div>
                          </div>
                          {error && <p className="text-danger">{error}</p>}
                          <div className="mt-3 d-flex gap-2">
                            <button type="submit" className="btn btn-primary" disabled={isCompDisabled}>
                              {isCompSubmitted ? "Submit" : "Submit"}
                            </button>
                          </div>
                        </form>
                      )}
                    </CardText>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ClassConfirmation;
